import React, { useState, useMemo } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import {
  Grid, Paper, Button, Avatar, Tooltip, Divider, Fab, Typography,
  InputBase, InputAdornment, IconButton
} from '@material-ui/core'

import Keyboard from '@material-ui/icons/Keyboard'
import PolicyIcon from '@material-ui/icons/Policy'
import SearchIcon from '@material-ui/icons/Search'
import ClearIcon from '@material-ui/icons/Clear'

import { getWordDetails } from '../../../../redux/actions'

import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'

// import FormControlLabel from '@material-ui/core/FormControlLabel'

import { withStyles } from '@material-ui/core/styles'

import { getSeverityClass, truncateText } from '../../../../utils'

// import { BaseToast } from '../../tools/Toast'

const DarkTooltip = withStyles((theme) => ({
  tooltip: {
    boxShadow: theme.shadows[1],
    fontSize: 12,
    leavTouchDelay: 10000
  }
}))(Tooltip)

/**
 * Returns word vault list form
 */
const WordVaultList = ({
  setVaultForm, unitName, wordVault, selectedKey, useStyles
}) => {
  const classes = useStyles()
  const dispatch = useDispatch()

  const categories = useSelector(state => state.words.categories)

  const [searchVal, setSearchVal] = useState('')
  const [wordsInfo, setWordsInfo] = useState([])

  // const [baseWordsInfo, setBaseWordsInfo] = useState([])

  // useEffect(() => {
  //   if (wordVault) {
  //     const mappedVault = wordVault.map((wordInfo) => {
  //       const { categoryID } = wordInfo
  //       const category = categories.find((categoryInfo) => categoryInfo.categoryID === categoryID)
  //       return ({
  //         ...category,
  //         ...wordInfo
  //       })
  //     })
  //     setWordsInfo(mappedVault)
  //     // setBaseWordsInfo(mappedVault)
  //   }
  // }, [wordVault, categories])

  useMemo(() => {
    if (wordVault && categories) {
      const mappedVault = wordVault.map((wordInfo) => {
        const { categoryID } = wordInfo
        const category = categories.find((categoryInfo) => categoryInfo.categoryID === categoryID)
        return ({
          ...category,
          ...wordInfo
        })
      })
      setWordsInfo(mappedVault)
    }
  }, [wordVault, categories])

  const avatarBackground = (severity) => {
    switch (getSeverityClass(severity * 2)) {
      case 'mild': return classes.mild
      case 'bad': return classes.bad
      case 'okay': return classes.okay
      case 'notGreat': return classes.notGreat
      case 'warn': return classes.warn
      default: return null
    }
  }

  // const onSearch = (text, setSearchText) => {
  //   const target = text.toUpperCase()
  //   const results = baseWordsInfo.filter((word) => {
  //     return word.phrase.toUpperCase().includes(target) || word.categoryName.toUpperCase().includes(target) || word.categoryDesc.toUpperCase().includes(target)
  //   })
  //   if (results.length === 0) {
  //     BaseToast('info', 'No matches for this word in this unit.')
  //     setWordsInfo(baseWordsInfo)
  //     setSearchText('')
  //   } else {
  //     setWordsInfo(results)
  //   }
  // }

  // const clearSearch = () => {
  //   if (Object.keys(unitWordVault).length === 0) {
  //     dispatch(getWordVault(selectedKey))
  //   } else {
  //     if (unitWordVault.unitID !== selectedKey) {
  //       dispatch(getWordVault(selectedKey))
  //     } else {
  //       setWordVault(unitWordVault)
  //     }
  //   }

  //   if (wordVault) {
  //     const mappedVault = wordVault.map((wordInfo) => {
  //       const { categoryID } = wordInfo
  //       const category = categories.find((categoryInfo) => categoryInfo.categoryID === categoryID)
  //       return ({
  //         ...category,
  //         ...wordInfo
  //       })
  //     })
  //     setWordsInfo(mappedVault)
  //   }
  // }

  const handleWordEdit = (wordID) => {
    dispatch(getWordDetails(selectedKey, wordID))
    setVaultForm('edit')
  }

  const filterWords = wordsInfo.filter((word) => {
    return word.phrase.toLowerCase().includes(searchVal.toLowerCase()) ||
      word.categoryName.toLowerCase().includes(searchVal.toLowerCase()) ||
      word.categoryDesc.toLowerCase().includes(searchVal.toLowerCase())
  })

  const listWords = () => {
    return (
      <>
        <Paper elevation={2} className={classes.vaultPaper}>
          <Grid container direction='column' justify='center' className='px-3 w-100 py-3'>

            <Grid container item>
              <Grid container item xs={8} alignContent='center'>
                <Typography component='h5' variant='h5'>{unitName.replace(/_/g, ' ')} Word Vault</Typography>
              </Grid>
              <Grid container item xs={4} justify='flex-end'>
                <Button variant='contained' className={classes.backBtn} onClick={() => setVaultForm('main')}>Back</Button>
              </Grid>
            </Grid>

            <Grid container item justify='center' className='my-3'>
              <Grid item xs={10}>
                <div className={classes.search}>
                  <div className={classes.searchIcon}>
                    <Fab
                      className={classes.searchBtn}
                      size='small'
                    >
                      <SearchIcon />
                    </Fab>
                  </div>
                  <InputBase
                    placeholder='Search word or category'
                    classes={{
                      root: classes.inputRoot,
                      input: classes.inputInput
                    }}
                    inputProps={{ 'aria-label': 'search' }}
                    onChange={(e) => setSearchVal(e.target.value)}
                    value={searchVal}
                    endAdornment={
                      <>
                        {
                          searchVal !== ''
                            ? (
                              <InputAdornment position='start'>
                                <IconButton onClick={() => setSearchVal('')}>
                                  <ClearIcon />
                                </IconButton>
                              </InputAdornment>
                            ) : (
                              <></>
                            )
                        }
                      </>
                    }
                  />
                </div>
              </Grid>
            </Grid>

            <Grid container item justify='center' className={classes.wordContainer}>
              {
                filterWords.length === 0 && searchVal !== ''
                  ? (
                    <Typography variant='h6' compoennt='h6'>No matches for this word in this unit.</Typography>
                  ) : filterWords.map((wordInfo) => {
                    return (
                      <Card key={`word-${wordInfo.wordID}`} className={classes.wordCard} raised>
                        <Grid container direction='row' spacing={2}>
                          <Grid container item xs={8} direction='column' className=''>
                            <CardContent className={classes.wordContent}>
                              <Grid container direction='row'>
                                <Grid container item xs={12} direction='column'>

                                  <Grid item>
                                    {
                                      wordInfo.phrase.length !== 15
                                        ? (
                                          <Typography variant='h6' component='h6' align='left'>{wordInfo.phrase}</Typography>
                                        ) : (
                                          <DarkTooltip title={wordInfo.phrase} placement='top-start'>
                                            <Typography variant='h6' component='h6' align='left'>
                                              {truncateText(wordInfo.phrase, 15)}
                                            </Typography>
                                          </DarkTooltip>
                                        )
                                    }
                                  </Grid>

                                  <Grid item>
                                    <Typography align='left' variant='caption' component='p'>
                                      <span className={`text-dark ${classes.categoryTitle}`}>Category: </span>
                                      <span className='text-muted'>{wordInfo.categoryName}</span>
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Grid>

                              <Grid container item className='pb-2'>
                                <Grid item xs={8} container alignContent='center'>
                                  {
                                    wordInfo.excluded === 0
                                      ? (
                                        <Typography variant='overline' className={classes.enableText}>
                                          Enabled
                                        </Typography>
                                      ) : (
                                        <Typography variant='overline' color='error' className={classes.disabledText}>
                                          Disabled
                                        </Typography>
                                      )
                                  }
                                </Grid>

                                <Grid item xs={4} container justify='flex-end' alignContent='center'>
                                  <Button
                                    variant='contained'
                                    className={classes.editBtn}
                                    onClick={() => { handleWordEdit(wordInfo.wordID) }}
                                  >
                                    Edit
                                  </Button>
                                </Grid>
                              </Grid>
                            </CardContent>
                          </Grid>

                          <Grid container item xs={4} className=''>
                            <Avatar variant='square' className={`${classes.severity} ${avatarBackground(wordInfo.severity)}`}>
                              <Grid container direction='column' justify='center' spacing={1}>
                                <Grid item container direction='row' justify='center' spacing={3}>
                                  <Grid item container alignContent='center' xs={6} direction='row' justify='flex-end'>
                                    <Keyboard />
                                  </Grid>

                                  <Grid item container alignContent='center' xs={6} direction='row' justify='flex-start'>
                                    <Typography variant='h5' component='h5' align='center' className='font-weight-bold'>
                                      {
                                        wordInfo.keyboard === 1
                                          ? wordInfo.severity > 50
                                            ? 100 : (parseInt(wordInfo.severity, 10) * 2)
                                          : '-'
                                      }
                                    </Typography>
                                  </Grid>
                                </Grid>

                                <Grid item container direction='row' justify='center'>
                                  <Divider variant='middle' light className={avatarBackground(wordInfo.severity) === classes.warn ? classes.darkScoreDivider : classes.scoreDivider} />
                                </Grid>

                                <Grid item container direction='row' justify='center' spacing={3}>
                                  <Grid item container alignContent='center' xs={6} direction='row' justify='flex-end'>
                                    <PolicyIcon />
                                  </Grid>

                                  <Grid item container alignContent='center' xs={6} direction='row' justify='flex-start'>
                                    <Typography variant='h5' component='h5' align='center' className='font-weight-bold'>
                                      {
                                        wordInfo.application === 1
                                          ? wordInfo.severity : '-'
                                      }
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Avatar>
                          </Grid>
                        </Grid>
                      </Card>
                    )
                  })
              }
            </Grid>
          </Grid>
        </Paper>
      </>
    )
  }

  return (
    <>
      {listWords()}
    </>
  )
}

export default WordVaultList
